//TODO: Tests
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import AcademyLeftNavBar from '../sidebarNav/AcademyLeftNavBar';
import AcademyHeroHeader from './AcademyHeader';
import AcademyIndexGrid from './AcademyIndexGrid';
import AcademySearch from './AcademySearch';
import NoTutorialsFound from './NoTutorialsFound';
import ArticleGridSkeleton from '../../shared/ArticleGridSkeleton';
import Layout from '../../../layout/Layout';

import { AcademyPageProps } from '../../../types/pages/academy/academy';
import { ArticleIndexItem, ArticleQuery } from '../../../types/api/AcademyTypes';
import { PagedResponse } from '../../../types/api/Http';

import academyIndexHelpers from '../../../helpers/academyIndexHelpers';

const AcademyIndexPage: React.FC<AcademyPageProps> = ({
  initialFilters = {}
}) => {
  const [selectedFilters, setSelectedFilters] = useState<ArticleQuery>(initialFilters);
  const [sidebarFilters, setSidebarFilters] = useState<ArticleQuery>(initialFilters);
  const [articles, setArticles] = useState<PagedResponse<ArticleIndexItem>>(null);
  const [totalArticles, setTotalArticles] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);

  const dispatch = useDispatch();
  const { getArticles } = academyIndexHelpers;

  const filterArticles = (filters: ArticleQuery) => {
    setSidebarFilters(filters);
    const search = selectedFilters.search;
    const $selectedFilters = {
      ...filters,
      search,
    };
    setSelectedFilters($selectedFilters);
    articlesInitialLoad($selectedFilters);
  };

  useEffect(() => {
    articlesInitialLoad(initialFilters);
  }, []);

  const articlesInitialLoad = async (selectedFilters?: ArticleQuery) => {
    setArticles(undefined);
    setInitialLoading(true);
    const response = await getArticles(dispatch, selectedFilters);
    setInitialLoading(false);
    if (!response) return;
    setArticles(response);
    setTotalArticles(response.total_count);
  };

  const loadNextPage = async () => {
    const nextPage = articles.next_page;
    if (loading || initialLoading || !nextPage) return;
    setLoading(true);
    const response = await getArticles(dispatch, {
      ...selectedFilters,
      page: [nextPage],
    });
    setLoading(false);
    if (!response) return;
    const updatedArticlesList = [ ...articles.data, ...response.data ];
    setArticles({
      ...response,
      data: updatedArticlesList,
    });
  };

  const handleSearch = (term: string) => {
    const search = term || '';
    const $selectedFilters: ArticleQuery = {
      ...selectedFilters,
      search: [search],
    };
    setSelectedFilters($selectedFilters);
    articlesInitialLoad($selectedFilters);
  };

  const renderGrid = (): React.ReactElement => {
    if (!articles) return;
    return (
      articles?.total_count === 0 ? (
        <NoTutorialsFound />
      ) : (
        <AcademyIndexGrid
          articles={articles}
          loadNextPage={loadNextPage}
        />
      )
    );
  }

  return (
    <Layout head={{ title: 'Academy' }}>
      <div className="flex flex-col md:flex-row w-full bg-[#252A2D]">
        <AcademyLeftNavBar
          selectedFilters={sidebarFilters}
          setSelectedFilters={filterArticles}
          filtersDisabled={initialLoading}
        />
        <div className="w-full md:min-w-[450px] p-4 lg:p-8">
          <AcademyHeroHeader tutorialsTotal={totalArticles} />
          <AcademySearch
            onSearch={handleSearch}
            defaultSearchTerm={''}
            isLoading={false}
          />
          <ArticleGridSkeleton visible={initialLoading} />
          {renderGrid()}
        </div>
      </div>
    </Layout>
  );
};

export default AcademyIndexPage;
